import {Image} from './Image';
import {AgeGroup} from './AgeGroup';

/**
 * Represents an over-seasonal team of a club.
 */
export class Team {
  readonly id: number;
  readonly slug: string;
  readonly club_id: number;
  readonly names: {
    middle: string;
    full: string;
    short: string;
  };
  readonly level: number;
  readonly image?: Image;
  readonly ageGroup?: AgeGroup;
}
